<template>
    <aside>
        <ul class="nav-menu pb-8">
            <li class="nav-menu-list">
                <a class="nav-menu-link" :href="env.VUE_APP_ALICE_URL + env.VUE_APP_MENU_PANEL">Painel de controle</a>
            </li>

            <li class="nav-menu-list">
                <a class="nav-menu-link" :href="env.VUE_APP_ALICE_URL + env.VUE_APP_MENU_ACCOUNT">Conta</a>
            </li>

            <li class="nav-menu-list">
                <a class="nav-menu-link" :href="env.VUE_APP_ALICE_URL + env.VUE_APP_MENU_ADDRESS">Endereço</a>
            </li>

            <li class="nav-menu-list">
                <a class="nav-menu-link exact-active router-link-active" href="/meus-pedidos">Pedidos</a>
            </li>

            <li class="nav-menu-list">
                <a class="nav-menu-link" :href="env.VUE_APP_ALICE_URL + env.VUE_APP_MENU_WISHLIST">Favoritos</a>
            </li>

            <li class="nav-menu-list">
                <a class="nav-menu-link" :href="env.VUE_APP_ALICE_URL + env.VUE_APP_MENU_NEWSLETTER">Newsletter</a>
            </li>

            <li class="nav-menu-list">
                <a class="nav-menu-link" :href="env.VUE_APP_ALICE_URL + env.VUE_APP_MENU_COUPON">Cupom</a>
            </li>

            <!--TODO: Linkar para pagina 3-->
            <li
                   v-if="debug"
                class="nav-menu-list">
                <div class="py-2 bg-gray-moblyCEC rounded-lg">
                    <div>
                        <p class="px-5 pb-2 text-center text-base font-light">Acompanhe seus atendimentos</p>
                    </div>
                    <div class="mx-4 mb-2 p-1 rounded-lg bg-black shadow-md">
                        <a
                            class="nav-menu-link"
                            :href="`${env.VUE_APP_CS_EXTERNAL_URL}/redirect-my-tickets`"
                            target="_blank"
                        >Meus atendimentos</a>
                    </div>
                </div>
            </li>
        </ul>
        <div class="flex justify-center" v-show="this.$route.params.id">
            <router-link
                :to="this.routerBack()"
                class="flex items-center text-xl font-extralight text-gray-500 mr-2 hover:text-gray-500"
            >
                <ChevronLeftIcon
                    size="1.5x"
                    class="text-red-mobly-light"
                />
                Voltar
            </router-link>
        </div>
    </aside>
</template>

<script>
import namespace from '../../vuex/namespace'
import { mapState } from 'vuex'
import { ChevronLeftIcon } from '@vue-hero-icons/solid'

export default {
  name: 'NavSide',
  components: {
    ChevronLeftIcon
  },
  data () {
    return {
      debug: false
    }
  },
  computed: {
    env: function () {
      return process.env
    },
    ...mapState(namespace.ORDERS, [
      'list'
    ]),
    ...mapState(namespace.ORDERS, [
      'status',
      'page'
    ])
  },
  mounted () {
    this.setDebug()
  },
  methods: {
    setDebug: function () {
      // if (!this.$route.query || !this.$route.query.debug) return

      // const value = this.$route.query.debug

      // if (value !== 'oq2jA') return

      this.debug = true
    },
    routerBack: function () {
      const path = '/meus-pedidos?page=' + this.page + '&filter=' + this.status + ''

      return path
    }
  }
}
</script>

<style scoped>

</style>
